import React, { useEffect } from 'react'
import { Draggable, DraggingStyle, NotDraggingStyle } from 'react-beautiful-dnd'
import {  DraggableItemIF } from './DraggableList'
import { useComponentHeight } from '../../hooks/useComponentHeight'

type OwnProps<T> = DraggableItemIF<T> & {
    onDelete?: () => void
    registerHeight?: (height: number) => void
}
export const grid = 4

const getItemStyle = (
    isDragging: boolean,
    draggableStyle: DraggingStyle | NotDraggingStyle | undefined
) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    // padding & marging of single item + Statement
    // padding: grid * 2,
    // margin: `0 0 ${grid}px 0`,
    width: '100%',
    // borderStyle: 'solid',
    // borderWidth: '1px',

    // change background colour if dragging
    // background: isDragging ? 'lightgrey' : 'white',

    // styles we need to apply on draggables
    ...draggableStyle,
})

export const DraggableRow = <T,>(p: OwnProps<T>) => {
    const {ref: hRef, height} = useComponentHeight(p);
    // info('DraggableList', {height})
    useEffect(() => {
        height && p.registerHeight?.(height)
    }, [height])
    return (
        <Draggable 
            draggableId={p.id}
            key={p.id}
            isDragDisabled={p.disabled}
            index={p.index} >
            {(provided, snapshot) => (
                <div
                    ref={ref=> {
                        provided.innerRef(ref);
                        hRef.current = ref;
                    }}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={
                        getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                        ) as any
                    }
                >
                    {p.renderedComponent && p.renderedComponent}
                </div>
            )}
        </Draggable>
    )
}
